<template>
  <PortalLayout :account="account" :account-type="profile.type || ''" @logout="logout">
    <router-view />
  </PortalLayout>
</template>
<script>
import PortalLayout from '@/components/layouts/PortalLayout.vue';

export default {
  name: 'PortalSite',
  components: { PortalLayout },
  data: () => ({ previousTitle: '' }),
  computed: {
    profile() { return this.$store.getters.profile; },
    account() { return { name: this.profile.name || this.$t('ui.profile'), email: this.profile.email || '' }; },
    pageTitle() { return this.$route.meta.titleKey ? this.$t(this.$route.meta.titleKey) : ''; },
  },
  watch: { pageTitle: 'updateTitle' },
  created() { this.$store.commit('syncProfile'); },
  mounted() { this.previousTitle = document.title; this.updateTitle(); },
  beforeUnmount() { document.title = this.previousTitle; },
  methods: {
    updateTitle() { if (this.previousTitle) document.title = (this.pageTitle ? this.pageTitle + ' | ' : '') + 'Leader'; },
    async logout() { await this.$store.dispatch('logout'); window.location.assign('/login'); },
  },
};
</script>
